export default {
    // 基本文案
    base: {
        // loading页点击提示
        loading_tapTips: 'Нажмите на яйцо, чтобы начать',
        // 活动按钮
        rule_btn: 'Правила',
        // 下载按钮
        download_btn: 'ЗАГРУЗИТЬ',
        // 下载提示窗的slogan
        download_slogan:
            'Хозяин, возьми меня в игру «Король Авалона»! Будем сражаться и получать награды!',
        // 取消按钮
        cancel_btn: 'отмена ',
        // 关闭按钮
        close_btn: 'закрыть',
        // 确认按钮
        confirm_btn: 'подтверждать',
        // 兑换按钮
        redeem_btn: 'ЗАБРАТЬ',
        // 分享图片
        share_img: 'Поделиться',
        // 换一只领养
        changeDragon: 'Сменить дракона',
        // 确认领养并且对战
        adoptBattle: 'Выберите дракона и сражайтесь',
        // 查看战力说明
        score_rule_btn: 'О силе',
        // 中奖记录按钮
        record_btn: 'Список наград',
        // 总战力
        totalPower: 'Общая сила',
        // 未兑换战力
        unredeemedPower: 'Не потраченная сила',
        // 积分奖励
        scorePrize: {
            get_gift_one: 'Забрать подарочный набор за $20', // 奖励文案
            get_gift_two: 'Забрать подарочный набор за $20', // 奖励文案
            draw: 'Лотерея' // 奖励文案
        },
        // 好友页标题
        friendTitle: 'Битва дракона <span>%{name}</span> с друзьями',
        // loading页slogan
        loadingSlogan: 'Вырастите дракона и<br>получите шанс выиграть Switch!',
        // 暂无好友提示
        friendEmptyTips:
            '<span>Приглашайте</span> в игру друзей и получайте очки силы для новых розыгрышей',
        // 暂无好友对战记录
        norecord_tips: `
            <p>Друзья еще не пришли в игру.</p>
            <p>Коснитесь кнопки «Поделиться», чтобы похвастаться своим драконом и предложить друзьям сразиться с вами!</p>
            `,
        // 请输入名字
        enter_name: 'Введите свое имя',
        // 请输入邮箱
        enter_email: 'Введите адрес своей электронной почты',
        // 请输入正确格式邮箱
        enter_right_email:
            'Убедитесь, что адрес электронной почты указан верно',
        // 请输入国家
        enter_country: 'Укажите свою национальную принадлежность',
        // 请输入地址
        enter_address: 'Введите свой адрес',
        // 请输入手机号
        enter_phone: 'Введите номер своего телефона',
        // 请输入正确格式手机号
        enter_rightr_phone: 'Введите действующий номер телефона',
        // 活动结束
        activityEnd: `Событие "Дракон юбилея «Короля Авалона»" завершилось. Награды распределены. Спасибо за участие!
        Возможно, некоторые победители так обрадовались, что не ввели сведения, необходимые для получения наград. В этом случае просим вас зайти на страничку «Короля Авалона» в сети <a href="https://www.facebook.com/koadw/" style="color:#6eb7db;text-decoration: underline;">Facebook</a> и связаться с нами.
        Загрузите <a href="https://app.adjust.com/ts8zich_dz016n6" target="_blank" style="color:#6eb7db;text-decoration: underline;">King of Avalon</a> прямо сейчас, чтобы вырастить собственного дракона!`
    },
    popup: {
        // 请输入昵称
        inputNameTips: 'Введите свое имя',
        // 生成专属龙
        genDragonTips: 'Мы выводим вашего уникального дракона; подождите',
        // 战力不足
        noScoreTips:
            'Недостаточно силы. Коснитесь «Поделиться», пригласите больше друзей и получите очки силы для новых розыгрышей!',
        //  分享提示
        shareTips: `Приглашайте в игру друзей
        и получайте очки силы для
        новых розыгрышей`,
        // 下载提示
        loginTips: `Войдите в игру, выберите дракона и
        вступите в борьбу за право получить
        Switch и AirPods Pro!`,
        // 活动规则
        rule: {
            title: 'Правила',
            content: `
            <div class="rule-item">
                <h4>1. Продолжительность события:</h4>
                <p> с 14 июля 2021 года по 29 июля 2021 года</p>
            </div>
            <div class="rule-item">
                <h4>2. Правила:</h4>
                <p>Выбор дракона: чтобы выбрать дракона, необходимо войти в игру через аккаунты Facebook или VK. У каждого дракона свой внешний вид, имя и атрибуты. После выведения его уже нельзя изменить.</p>
                <p>Битва: вы можете пригласить своих друзей в игру. Как только они выберут драконов, ваши питомцы автоматически вступят в битву и принесут вам обоим очки силы. С одним другом можно сразиться не более 3 раз.</p>
                <p>Приглашения: поделившись игрой в Facebook/WhatsApp/VK, вы сможете пригласить больше друзей, готовых поиграть с вами.</p>
                <p>Сила: победа в битве приносит 300 очков силы, поражение — 200 очков силы. Загрузив игру «Король Авалона», вы получите 600 очков силы. Каждый из первых трех кликов по опубликованной ссылке принесет вам по 300 ед. силы. </p>
            </div>
            <div class="rule-item">
                <h4>3. Награды:</h4>
                <p>a. Наберите 300 очков силы, чтобы получить подарочный набор игры «Король Авалона» на сумму $20, и 600 очков силы, чтобы получить подарочный набор на сумму $20. Наберите 1000 очков силы, чтобы принять участие в лотерее и выиграть подарочный набор игры «Король Авалона» на сумму $20, подарочные карты Amazon на сумму $10 или $50, Switch, Sony PS5 или AirPods Pro.</p>
                <p>b. Общее количество подарочных наборов — 100 тысяч. После получения кода подарка войдите в игру и введите код в профиле игрока (Настройки - Код подарка), чтобы получить подарки. Коды действуют всего 3 месяца. Не забудьте вовремя забрать свои подарки!</p>
                <p>c. Общее количество подарочных карт Amazon — 38. Предметов, которые можно получить в подарок — 8. В случае выигрыша подарочной карты или предмета укажите свои личные данные, и наши сотрудники свяжутся с вами в течение 7 рабочих дней после окончания события.</p>
                <p>d. Имена игроков, выигравших подарочные карты или предметы, будут опубликованы на официальной странице игры «Король Авалона» в сети Facebook 30 июля 2021. Победители должны будут предоставить свои личные данные до 6 августа, ответив на полученные ими письма. Те, кто не ответит вовремя, не смогут получить награды.</p>
                <p>e. За их доставку в отдаленные локации, возможно, придется доплатить (в зависимости от логистики). Если доставка проходит неудачно из-за того, что игроки указали неполные или неверные сведения о себе, возмещения не предусмотрено. Кроме того, после отправки награды за ее пропажу, получение не тем человеком, кражу или любые другие потери во время или после доставки отвечает победитель. Мы не берем на себя ответственности за повторную отправку наград.</p>
            </div>
            <div class="rule-item"><p>4. FunPlus оставляет за собой право на окончательную интерпретацию события. Принимая участие в событии, вы соглашаетесь с ходом его проведения и разработанными его организаторами правилами. В случае обнаружения и подтверждения фактов нарушения правил, нарушения порядка игры или давления на других игроков мы оставляем за себя право отозвать все права и качества игроков.</p></div>
            `
        },
        // 战力说明
        powerInfo: {
            title: 'О силе',
            content: `
                    <p>1. Победа в битве приносит 300 очков силы, поражение — 200 очков силы. Загрузив игру «Король Авалона», вы получите 600 очков силы. Каждый из первых трех кликов по опубликованной ссылке принесет вам по 300 ед. силы.</p>
                    <p>2. Наберите 300 очков силы, чтобы получить подарочный набор игры «Король Авалона» на сумму $20, и 600 очков силы, чтобы получить подарочный набор на сумму $20. Наберите 1000 очков силы, чтобы принять участие в лотерее и выиграть подарочный набор игры «Король Авалона» на сумму $20, подарочные карты Amazon на сумму $10 или $50, Switch, Sony PS5 или AirPods Pro.</p>
                    <p>3. Подарки за 300/600 очков силы можно забрать только один раз, а для лотереи ограничений нет. В момент розыгрыша вы потеряете 1000 очков силы, и вам придется начать копить ее заново.</p>
                    <p>4. Чем больше общее кол-во накопленной вами силы, тем больше шансов на победу. Сила, которую вы обмениваете, не учитывается в битвах.</p>
                    <p>5. С одним другом можно сразиться не более 3 раз.</p>
                `
        },
        // 购物卡弹窗
        giftCard: {
            title: `Поздравляем! Ваш выигрыш: </br>
            【%{reward}】`,
            desc: `Оставьте свои данные, и наши сотрудники свяжутся с вами в течение 7 рабочих дней после окончания события.`,
            name: 'Имя',
            country: 'Страна',
            email: 'Адрес эл.</br>почты'
        },
        // 实物奖
        entity: {
            title: `Поздравляем! Ваш выигрыш: </br>
                        【%{reward}】`,
            desc: `Оставьте свои данные, и наши сотрудники
                    свяжутся с вами в течение 7
                    рабочих дней после окончания события.`,
            name: 'Имя',
            addr: 'Почтовый<br>адрес ',
            mobile: 'Номер<br>телефона',
            email: 'Адрес эл.<br>почты'
        },
        // 兑换码弹窗
        code: {
            title: `Поздравляем! Ваш выигрыш: <br> 【%{reward}】!`,
            label: 'разменный код',
            // 一键复制按钮
            copy_btn: 'СКОПИРОВАТЬ',
            // 跳转兑换按钮
            redeem_btn: 'ЗАБРАТЬ',
            // 复制礼包码成功
            copy_success: 'Код подарка скопирован'
        },
        draw: {
            // 中奖资料填写成功
            fillSucc:
                'Отправлено! Наши сотрудники свяжутся с вами в течение 7 рабочих дней после окончания события.',
            free:
                'Поздравляем! Вы закончили первую битву<br>и выиграли бесплатный розыгрыш в лотерею!',
            // 未中奖文案
            noReward: `Похоже, на этот раз вам не повезло. Поделитесь игрой с друзьями, получите больше силы и попробуйте еще раз!`
        },
        // 好友页
        friend: {
            name: 'Имя',
            battles: 'Битвы',
            power: 'Сила',
            battleAgain: 'Сразиться<br>снова'
        },
        // 中奖记录
        record: {
            title: 'Список наград',
            record_time: 'Время получения награды',
            record_name: 'Награда получена'
        }
    },
    game: {
        slogan: [
            'Пора с кем-нибудь сразиться!',
            'Как насчет дуэли?',
            'Ну и силища!',
            'Давай сразимся!',
            'Расскажи обо мне друзьям, чтобы начать битву!',
            'Коснись меня, и мы поболтаем!',
            'Хочу сражаться!',
            'Ну, как настроение?',
            'Какая у тебя любимая песня, хозяин?',
            'Хозяин, ты знаешь, где находится Глаз Сахары?',
            'Я очень хочу поехать в Исландию, а ты?',
            'Не забудь надеть маску!',
            'Как же хочется сочных бургеров! А тебе?',
            'Хозяин, может быть, мне пора худеть?',
            'Ура, ура, ура!',
            'Тра-ля-ля!',
            'Однажды нам повезет!',
            'Кто рано ложится, того беда боится!',
            'Не расстраивайся!',
            'Никто не может знать все на свете!',
            'Я вырасту и стану настоящим огнедышащим драконом!',
            'Хозяин, ты любишь игры? Говорят, моих братьев можно встретить в игре «Король Авалона»!',
            'Моргана, даже не надейся, что на этот раз тебе удастся скрыться!',
            'Говорят, загадочная кнопка «Загрузить» может сделать тебя сильнее!'
        ]
    },
    msg: {
        // pk次数限制文案
        pklimit:
            'С одним другом можно сразиться не более 3 раз. Приглашайте больше друзей и получайте очки силы для новых розыгрышей!',
        // 长按保存相片提示
        pressimg2savepicture:
            'Нажмите и удерживайте для сохранения изображения',
        // 等待文案
        waiting: 'loading...'
    }
};
